import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";

//graphql
import { useQuery } from "@apollo/client";
import { GET_DEVICES } from "../queries";

//redux
import { useAppDispatch } from "../hooks/reduxHooks";
import { updatePageButtons, updatePageTitle } from "../store/layout";

//components
import DeviceTable from "./components/DeviceTable";
import DeviceGrid from "./components/DeviceGrid";
const Home = () => {
	const dispatch = useAppDispatch();
	const [Devices, setDevices] = useState<[Device] | null>(null);
	const [JobSummaries, setJobSummaries] = useState<[JobSummary] | null>(null);
	const { search } = useLocation();

	const pQuery = useMemo(() => new URLSearchParams(search), [search]);

	const [viewType, setViewType] = useState(pQuery.get("view") || localStorage.getItem("defaultCouterView") || "table");

	const pageButtons: PageButton[] = useMemo(
		() => [
			{
				key: 1,
				label: "Grid",
				link: "?view=grid",
				disabled: false,
				active: viewType === "grid",
			},
			{
				key: 2,
				label: "Table",
				link: "?view=table",
				disabled: false,
				active: viewType === "table",
			},
		],
		[viewType]
	);

	const dataLoaded = (d: { countcDevices: [Device]; countcCountSummaries: [JobSummary] }) => {
		//sort devices by title
		let sortedDevices = [...d.countcDevices] as [Device];
		sortedDevices?.sort((a, b) => {
			if (a.Title && b.Title) {
				if (a.Title < b.Title) {
					return -1;
				}
				if (a.Title > b.Title) {
					return 1;
				}
			}
			return 0;
		});
		setDevices(sortedDevices);
		setJobSummaries(d.countcCountSummaries);
	};

	useEffect(() => {
		dispatch(updatePageTitle("Counters"));
		dispatch(updatePageButtons(pageButtons));
	}, [dispatch, pageButtons]);

	useEffect(() => {
		let requestedVew = pQuery.get("view");
		if (requestedVew) {
			localStorage.setItem("defaultCouterView", requestedVew);
			setViewType(requestedVew);
		}
	}, [search, pQuery, setViewType]);

	useEffect(() => {
		dispatch(updatePageButtons(pageButtons));
	}, [viewType, dispatch, pageButtons]);

	const { error, refetch } = useQuery(GET_DEVICES, {
		variables: { id: 0 },
		onCompleted: dataLoaded,
		notifyOnNetworkStatusChange: true,
		pollInterval: 15000,
	});

	if (error) return <pre>{error.message}</pre>;

	if (viewType === "table") {
		return <DeviceTable Devices={Devices} JobSummaries={JobSummaries} refetch={refetch} />;
	} else {
		return <DeviceGrid Devices={Devices} JobSummaries={JobSummaries} refetch={refetch} />;
	}
};

export default Home;
